/* ── SmartPack Core — Cart line tools ── */
(function () {
  'use strict';
  if (window.__spCartLineTools) return;
  window.__spCartLineTools = 1;

  var nativeFetch = window.fetch.bind(window);

  function P() { return window.SPPricing || null; }

  function num(n)                { var p = P(); return p ? p.num(n) : String(n); }
  function money(c)              { var p = P(); return p ? p.money(c) : ''; }
  function onceLadder(d)         { var p = P(); return p ? p.onceLadder(d) : []; }
  function blanketLadder(d, pid) { var p = P(); return p ? p.blanketLadder(d, pid) : []; }
  function selectedIndex(t, q)   { var p = P(); return p ? p.selectedIndex(t, q) : 0; }
  function tierLabel(t, i, cap)  { var p = P(); return p ? p.tierLabel(t, i, cap) : ''; }
  function subMin()              { var p = P(); return p ? p.SUB_MIN : 500; }
  function subStep()             { var p = P(); return p ? p.SUB_STEP : 500; }
  function perYear(pid)          { var p = P(); return p ? p.perYear(pid) : 0; }

  function capFor(data, planId) {
    if (!data) return null;
    return planId ? (data.arCap || null) : (data.onceCap || null);
  }
  function overCap(data, qty, planId) {
    var cap = capFor(data, planId);
    if (!cap) return false;
    var annual = planId ? qty * perYear(planId) : qty;
    return annual > cap;
  }
  function quoteHref(tools, qty, planId) {
    var url = tools.getAttribute('data-sp-line-url') || '';
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'qty=' + qty + (planId ? '&mode=auto-reorder' : '');
  }
  function paintQuote(tools, data) {
    var item = tools.closest('.cart-item');
    var q = tools.querySelector('[data-sp-line-quote]');
    var planId = tools.getAttribute('data-sp-line-plan') || '';
    var qty = lineQty(tools);
    var over = overCap(data, qty, planId);
    if (item) item.classList.toggle('is-quote', over);
    if (!q) return;
    if (over) {
      var cap = capFor(data, planId);
      var limit = planId ? num(cap) + ' pieces a year' : num(cap) + ' pieces';
      var link = quoteHref(tools, qty, planId);
      q.innerHTML = '<b>Above ' + limit + ' this is list price.</b> ' +
        'At this size we can almost always do better' +
        (link ? ' — <a href="' + link + '">ask for a quote &rarr;</a>' : '.');
      q.hidden = false;
    } else {
      q.hidden = true;
      q.innerHTML = '';
    }
  }

  function bandsFor(tools) {
    if (tools.__spBands) return tools.__spBands;
    var el = tools.querySelector('[data-sp-line-bands]');
    try { tools.__spBands = JSON.parse(el.textContent); } catch (e) { tools.__spBands = null; }
    return tools.__spBands;
  }

  function renderTable(tools) {
    var mini = tools.querySelector('[data-sp-line-mini]');
    var card = tools.querySelector('[data-sp-line-ladder]');
    var box = tools.querySelector('[data-sp-line-table]');
    var data = bandsFor(tools);
    if (!mini || !card || !box) return;
    if (!data) { mini.hidden = true; card.hidden = true; return; }
    var plan = tools.getAttribute('data-sp-line-plan') || '';
    if (!P() || (plan && !window.SPBlanket)) { setTimeout(function () { renderTable(tools); }, 150); return; }
    var qty = parseInt(tools.getAttribute('data-sp-line-qty'), 10) || 0;
    paintQuote(tools, data);
    var tiers = plan ? blanketLadder(data, plan) : onceLadder(data);
    if (tiers.length < 2) { mini.hidden = true; card.hidden = true; return; }

    var S = selectedIndex(tiers, qty);
    var expanded = !!tools.__spExpanded;
    var floor = tiers[tiers.length - 1].cents;

    var idxs = [];
    if (expanded) {
      for (var i = 0; i < tiers.length; i++) idxs.push(i);
    } else {
      idxs.push(S);
      if (S + 1 < tiers.length) idxs.push(S + 1);
    }
    var html = idxs.map(function (i2) {
      var t = tiers[i2];
      return '<button type="button" class="cart-line-tools__row' + (i2 === S ? ' is-current' : '') + '"' +
        ' data-sp-line-tier="' + t.min + '">' +
        '<span>' + tierLabel(tiers, i2, plan ? null : data.onceCap) + '</span><span>' + money(t.cents) + '</span></button>';
    }).join('');
    if (tiers.length > idxs.length || expanded) {
      html += '<button type="button" class="cart-line-tools__more" data-sp-line-expand>' +
        (expanded ? 'Show fewer tiers'
                  : 'Show all ' + tiers.length + ' tiers – as low as ' + money(floor) + '/pc') +
        '</button>';
    }
    box.innerHTML = html;
    mini.hidden = true;
    card.hidden = false;
  }

  function scanAll() {
    document.querySelectorAll('[data-sp-line-tools]').forEach(function (tools) {
      if (!tools.__spRendered) { tools.__spRendered = true; renderTable(tools); }
    });
  }

  /* ── The one change call ── */

  function apply(tools, newQty, newPlanId) {
    if (tools.__spBusy) return;
    tools.__spBusy = true;
    tools.style.opacity = '.5';
    var key = tools.getAttribute('data-sp-key');
    var planId = newPlanId != null ? String(newPlanId) : (tools.getAttribute('data-sp-line-plan') || '');

    nativeFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var it = null;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].key === key) { it = cart.items[i]; break; }
        }
        if (!it) throw new Error('line not found');

        var body = { id: key, quantity: newQty };
        if (planId) {
          body.selling_plan = parseInt(planId, 10);
          var merged = {};
          var existing = it.properties || {};
          Object.keys(existing).forEach(function (k) { merged[k] = existing[k]; });
          var band = window.SPBlanket ? SPBlanket.spBandValue(newQty, planId, bandsFor(tools)) : null;
          if (band) {
            merged._sp_band = band;
          } else {
            delete merged._sp_band;
            document.dispatchEvent(new CustomEvent('sp:line-band-unavailable', {
              detail: { key: key, qty: newQty, planId: planId }
            }));
          }
          body.properties = merged;
        }

        return nativeFetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });
      })
      .then(function (r) { return r.json(); })
      .then(function () { window.location.reload(); })
      .catch(function () {
        tools.__spBusy = false;
        tools.style.opacity = '';
      });
  }

  /* ── Delegated controls ── */

  function toolsFor(el) { return el.closest ? el.closest('[data-sp-line-tools]') : null; }
  function lineQty(tools) { return parseInt(tools.getAttribute('data-sp-line-qty'), 10) || 0; }

  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel || !sel.matches || !sel.matches('[data-sp-line-freq]')) return;
    var t = toolsFor(sel);
    if (t && sel.value !== t.getAttribute('data-sp-line-plan')) apply(t, lineQty(t), sel.value);
  });

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    var row = e.target.closest('[data-sp-line-tier]');
    if (row) {
      var t2 = toolsFor(row);
      if (t2) apply(t2, parseInt(row.getAttribute('data-sp-line-tier'), 10));
      return;
    }

    var more = e.target.closest('[data-sp-line-expand]');
    if (more) {
      var t3 = toolsFor(more);
      if (t3) { t3.__spExpanded = !t3.__spExpanded; renderTable(t3); }
    }
  });

  /* every custom line, scheduled or not — the tools only render for custom products */
  function customToolsForControl(el) {
    var item = el.closest ? el.closest('.cart-item') : null;
    return (item && item.querySelector('[data-sp-line-tools]')) || null;
  }
  function scheduled(tools) { return !!tools.getAttribute('data-sp-line-plan'); }

  function snapSub(q)  { var p = P(); return p ? p.snapSub(q)  : q; }
  function snapOnce(q) { var p = P(); return p ? p.snapOnce(q) : q; }
  function onceMin()   { var p = P(); return p ? p.ONCE_MIN  : 50; }
  function onceStep()  { var p = P(); return p ? p.ONCE_STEP : 50; }

  function minFor(tools)     { return scheduled(tools) ? subMin()  : onceMin(); }
  function stepFor(tools)    { return scheduled(tools) ? subStep() : onceStep(); }
  function snapFor(tools, q) { return scheduled(tools) ? snapSub(q) : snapOnce(q); }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest('[data-quantity-increase], [data-quantity-decrease]');
    if (!btn) return;
    var tools = customToolsForControl(btn);
    if (!tools) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var dir = btn.hasAttribute('data-quantity-increase') ? 1 : -1;
    apply(tools, snapFor(tools, lineQty(tools) + dir * stepFor(tools)));
  }, true);

  document.addEventListener('change', function (e) {
    var inp = e.target;
    if (!inp || !inp.matches || !inp.matches('[data-quantity-input]')) return;
    var tools = customToolsForControl(inp);
    if (!tools) return;
    e.stopImmediatePropagation();
    var q = parseInt(String(inp.value).replace(/[^0-9]/g, ''), 10) || minFor(tools);
    apply(tools, Math.max(minFor(tools), Math.ceil(q / stepFor(tools)) * stepFor(tools)));
  }, true);

  /* ── Boot ── */
  function init() {
    scanAll();
    new MutationObserver(function () { scanAll(); }).observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
